import {useMemo} from 'react'
import useIsMounted from '@github-ui/use-is-mounted'
import {throttle} from '@github/mini-throttle'
import {useAlive} from '@github-ui/use-alive'
import {useChangeGroupsData} from '../page-data/loaders/use-change-groups-data'

export function useChangeGroupsLiveUpdates(
  channel: string,
  baseSha: string | undefined,
  headSha: string | undefined,
): void {
  const isMounted = useIsMounted()
  const {refetch} = useChangeGroupsData(headSha, baseSha)
  const throttleRefetchingData = useMemo(
    () =>
      throttle(() => {
        if (isMounted()) {
          refetch()
        }
      }, 2000),
    [isMounted, refetch],
  )

  const handleChangeGroupChannelNotification = useMemo(
    () => (eventData: {wait?: number; base_commit_oid?: string; head_commit_oid?: string}) => {
      // we only want to refetch if the current base and head sha are the same as the ones sent with the channel event
      if (eventData?.base_commit_oid === baseSha && eventData?.head_commit_oid === headSha) {
        window.setTimeout(() => throttleRefetchingData(), eventData.wait || 0)
      }
    },
    [baseSha, headSha, throttleRefetchingData],
  )
  useAlive(channel, handleChangeGroupChannelNotification)
}
